<script setup>
defineProps({
  items: {
    type: Array,
  },
})
</script>

<template>
  <nav
    class="med-bread"
    aria-label="Breadcrumb"
  >
    <ol>
      <li
        v-for="item in items"
        :key="item.id"
      >
        <NuxtLink :to="useCmsUrl(item.to)">
          {{ item.label }}
        </NuxtLink>
      </li>
    </ol>
  </nav>
</template>

<style lang="scss">
.med-bread {
  margin-bottom: 10px;

  ol {
    list-style: none;
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    margin: 0;
  }

  li {
    display: flex;
    align-items: baseline;
    padding-left: 0;

    &:after {
      content: '>';
      margin-left: 5px;
      margin-right: 5px;
    }

    &:last-child:after {
      content: '';
    }
  }

  @media (min-width: 1200px) {
    margin-bottom: 20px;
  }
}
</style>
